import script from "./SpringFestivalDecorations.vue?vue&type=script&setup=true&lang=js"
export * from "./SpringFestivalDecorations.vue?vue&type=script&setup=true&lang=js"

import "./SpringFestivalDecorations.vue?vue&type=style&index=0&id=516ec830&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-516ec830"]])

export default __exports__